var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _dec20, _dec21, _dec22, _dec23, _dec24, _dec25, _dec26, _dec27, _dec28, _dec29, _dec30, _dec31, _dec32, _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _temp;

function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and set to use loose mode. ' + 'To use proposal-class-properties in spec mode with decorators, wait for ' + 'the next major version of decorators in stage 2.'); }

/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
import { CustomElement, Component, Prop, State, Watch, COMPONENT_STATE, Event, EventEmitter, html, classMap, styleMap, render } from '@sick-davinci/ce-decorators';
import { style } from './DropDown.style';
import { Option } from '../option/Option';
import { OptionGroup } from '../option/OptionGroup';
import { icon_expand_more } from '@sick-davinci/material-icons/navigation/expand_more.icon';
import { Spinner } from './../spinner/Spinner';
import { IconRef } from './../icon/IconRef';
/**
 * DropDownOption instancance
 */

export
/**
 * `davinci-drop-down` is a simple dropdown list and combo-box. 
 * If used as a combo-box (editable), the content of the text-field displays the value instead of the slot.
 * 
 * @example
 * ```html
 *  <davinci-drop-down list="trees" editable oninput="console.log(event.detail)">
 *      <davinci-option value="Maple"></davinci-option>
 *      <davinci-option value="Beech"></davinci-option>
 *      <davinci-option value="Pine"></davinci-option>
 *      <davinci-option value="Birch"></davinci-option>
 *      <davinci-option value="Spruce"></davinci-option>
 *      <davinci-option value="Oak"></davinci-option>
 *      <davinci-option value="Fir"></davinci-option>
 *      <davinci-option value="Ash"></davinci-option>
 *      <davinci-option value="Chestnut"></davinci-option>
 *  </davinci-drop-down>
 *  ```
 *  ## Known Issues
 *  If you are using Angular and forms deffer the .data call in a `window.setTimeout`
 *  
 *  ## UMD specific imports for using the contentRenderer
 *  If you need the ES5 version you have to import the template-tag html method from the umd
 *  ```typescript
 *  import { html } from '@sick-davinci/basic-elements/umd'
 *  
 *  const element = document.createElement('davinci-drop-down')
 *  element.contentRenderer = (value, label) => html`label: ${label} value: ${value}`;
 *  ```
 *  
 *  in Angular you can assign the function within a template
 *  template:
 *  ```html
 *  <davinci-drop-down [contentRenderer]="renderer"></davinci-drop-down>
 *  ```
 *  component:
 *  ```typescript
 *  import { html } from '@sick-davinci/basic-elements/umd'
 *  
 *  export class Component
 *  contentRenderer(value, label) {
 *      return html`label: ${label} value: ${value}`;
 *  }
 *  ```
 * @slot {davinci-option[] | davinci-option-group[]} `davinci-option` or `davinci-option-group` elements
 */
let DropDown = (_dec = Component({
  tag: 'davinci-drop-down',
  style: [style],
  dependencies: [Option, OptionGroup, Spinner, IconRef]
}), _dec2 = Reflect.metadata("design:paramtypes", []), _dec3 = Prop(), _dec4 = Reflect.metadata("design:type", String), _dec5 = Prop(), _dec6 = Reflect.metadata("design:type", String), _dec7 = Prop(), _dec8 = Reflect.metadata("design:type", Boolean), _dec9 = Prop(), _dec10 = Reflect.metadata("design:type", Boolean), _dec11 = Prop(), _dec12 = Reflect.metadata("design:type", Boolean), _dec13 = Prop(), _dec14 = Reflect.metadata("design:type", String), _dec15 = Prop({
  reflectAsAttribute: false,
  type: Object
}), _dec16 = Reflect.metadata("design:type", Object), _dec17 = Prop({
  reflectAsAttribute: false
}), _dec18 = Reflect.metadata("design:type", String), _dec19 = Prop(), _dec20 = Reflect.metadata("design:type", Boolean), _dec21 = State(), _dec22 = Reflect.metadata("design:type", Boolean), _dec23 = Event('change'), _dec24 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec25 = Event('input'), _dec26 = Reflect.metadata("design:type", typeof EventEmitter === "undefined" ? Object : EventEmitter), _dec27 = Prop({
  reflectAsAttribute: false
}), _dec28 = Reflect.metadata("design:type", Function), _dec29 = Watch('disabled'), _dec30 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec31 = Watch('expanded'), _dec32 = Reflect.metadata("design:paramtypes", [Boolean, Boolean]), _dec(_class = _dec2(_class = (_class2 = (_temp = class DropDown extends CustomElement {
  /**
   * Identifier for supporting forms. Reserved for future usage.
   */

  /**
   * Specifies a short hint that describes the expected value. Displayed only in case the value is empty.
   */

  /**
   * Specifies if the dropdown list is editable and becomes a combobox.
   */

  /**
   * Specifies that the dropdown should be disabled.
   */

  /**
   * Specifies displaying the loading indicator.
   */

  /**
   * Specifies the label on top of the input field. Default is *no* label.
   */

  /**
   * Manually set the dropdown data.
   */
  set data(value) {
    if (value instanceof Promise) {
      Promise.resolve().then(() => {
        this.loading = true;
      });
      value.then(result => {
        render(this._createOptionList(result), this);
        this.appendChild(this._currentValueContainer);
        this._currentSelection = null;
        Promise.resolve().then(() => {
          this.loading = false;
        });
      });
    } else {
      render(this._createOptionList(value), this);
      this.appendChild(this._currentValueContainer);
      this._currentSelection = null;
    }
  }

  get data() {
    const data = [...Array.from(this.children).filter(value => value.tagName === 'DAVINCI-OPTION-GROUP').map(optGroup => {
      return {
        label: optGroup.label,
        data: Array.from(optGroup.children).filter(value => value.tagName === 'DAVINCI-OPTION').map(opt => {
          return {
            label: opt.innerHTML || opt.value,
            value: opt.value || opt.innerHTML
          };
        })
      };
    }), ...Array.from(this.children).filter(value => value.tagName === 'DAVINCI-OPTION').map(opt => {
      return {
        label: opt.innerHTML || opt.value,
        value: opt.value || opt.innerHTML
      };
    })];
    return data;
  }
  /**
   * Get or set the value.
   */


  set value(value) {
    this._lastCommitedValue = value;
    this.internalValue = value;
    this.onListSlotChange(null);
  }

  get value() {
    return this.internalValue;
  }
  /**
   * Specifies if the dropdown list is expanded.
   */


  constructor() {
    super();

    _initializerDefineProperty(this, "name", _descriptor, this);

    _initializerDefineProperty(this, "placeholder", _descriptor2, this);

    _initializerDefineProperty(this, "editable", _descriptor3, this);

    _initializerDefineProperty(this, "disabled", _descriptor4, this);

    _initializerDefineProperty(this, "loading", _descriptor5, this);

    _initializerDefineProperty(this, "label", _descriptor6, this);

    _initializerDefineProperty(this, "expanded", _descriptor7, this);

    _initializerDefineProperty(this, "showPlaceholder", _descriptor8, this);

    _initializerDefineProperty(this, "change", _descriptor9, this);

    _initializerDefineProperty(this, "input", _descriptor10, this);

    this.internalValue = null;
    this.icon = icon_expand_more;
    this.listStyle = {
      'top': '0px',
      'max-height': '300px'
    };
    this._lastCommitedValue = null;
    this._currentSelection = null;
    this._currentAnimationFrame = null;
    this._lastTopPosition = null;
    this._listElement = null;
    this._overlayWrapper = null;

    _initializerDefineProperty(this, "contentRenderer", _descriptor11, this);

    this.onInputChange = event => {
      event.preventDefault();
      event.stopPropagation();
      this.internalValue = event.currentTarget.value;

      if (this._lastCommitedValue !== this.internalValue) {
        this._lastCommitedValue = this.internalValue;
        this.change.emit(this.internalValue);
      }
    };

    this.onInputInput = event => {
      event.preventDefault();
      event.stopPropagation();
      this.internalValue = event.currentTarget.value;
      this.input.emit(this.internalValue);
      this.scheduleRender(true);
    };

    this.onInputKeyDown = event => {
      if (event.key === 'Enter' && !this._currentSelection) {
        event.stopPropagation();

        if (this._lastCommitedValue !== this.internalValue) {
          this._lastCommitedValue = event.currentTarget.value;
          this.change.emit(this.internalValue);
        }

        this.expanded = false;
      }
    };

    this.onExpandClick = event => {
      event.preventDefault();
      event.stopPropagation();
      this.expanded = !this.expanded;
    };

    this.onKeyCapture = event => {
      switch (event.key) {
        case 'Down': // IE specific value

        case 'ArrowDown':
          event.preventDefault();

          if (!this.expanded) {
            this.expanded = true;
          } else {
            this._selectNextOption();
          }

          break;

        case 'Up': // IE specific value

        case 'ArrowUp':
          if (!this.expanded) {
            this.expanded = true;
          } else {
            event.preventDefault();

            this._selectPreviousOption();
          }

          break;

        case 'Enter':
          event.preventDefault();

          if (this._currentSelection) {
            this.selectItem(this._currentSelection);
          }

          break;

        case 'Spacebar':
        case ' ':
          if (this._currentSelection) {
            event.preventDefault();
            this.selectItem(this._currentSelection);
          }

          break;

        case 'Esc':
        case 'Escape':
          event.preventDefault();

          if (this.expanded) {
            this.expanded = false;
          }

          break;

        case 'Tab':
          if (this.expanded) {
            this.expanded = false;
          }

          break;

        default:
          return;
      }
    };

    this.onClickCapture = event => {
      if (event.target === this._overlayWrapper || event.target.tagName === 'INPUT') {
        this.expanded = false;
        event.preventDefault();
        event.stopPropagation();
      } else {
        const option = this._findDavinciOption(event.target);

        if (option) {
          event.stopPropagation();
          event.preventDefault();
          this.selectItem(option);
        } else {
          this.expanded = !this.expanded;

          if (this.expanded) {
            this.shadowRoot.querySelector('input').focus();
          }
        }
      }
    };

    this.onListSlotChange = _event => {
      this.querySelectorAll('div[slot=currentvalue]').forEach(value => {
        this.removeChild(value);
      });

      if (!this.editable) {
        const children = this.querySelectorAll('davinci-option');

        for (let i = 0; i < children.length; i++) {
          // tslint:disable-line
          if (children[i].tagName === 'DAVINCI-OPTION') {
            const currentChild = children[i];

            if (typeof currentChild.value === 'string' && currentChild.value === this.internalValue || (typeof currentChild.value !== 'string' || currentChild.value === '') && currentChild.textContent === this.internalValue) {
              this.showPlaceholder = false;
              this._currentValueContainer.innerHTML = currentChild.innerHTML;
              this.appendChild(this._currentValueContainer);
              return;
            } else if (typeof currentChild.value === 'string' && currentChild.value === this._lastCommitedValue || (typeof currentChild.value !== 'string' || currentChild.value === '') && currentChild.textContent === this._lastCommitedValue) {
              this.showPlaceholder = false;
              this._currentValueContainer.innerHTML = currentChild.innerHTML;
              this.appendChild(this._currentValueContainer);
              this.internalValue = this._lastCommitedValue;
              return;
            }
          }
        }

        this._currentValueContainer.innerHTML = this.placeholder || '';
        this.internalValue = null;
        this.showPlaceholder = true;
        this.appendChild(this._currentValueContainer);
      }
    };

    this.onAnimationFrame = () => {
      this._currentAnimationFrame = window.requestAnimationFrame(this.onAnimationFrame);

      this._calculateListDimensions();
    };

    this._currentValueContainer = document.createElement('div');

    this._currentValueContainer.setAttribute('slot', 'currentvalue');
  }
  /**
   * Custom renderer for data.
   * Example (make matched part bold) for overriding:
   * this.contentRenderer = (value, label) => html`
   *    <span>${label.substring(0, startIndex)}</span><!--
   *    --><span style="${styleMap({color: '#323c43'})}">${label.substring(startIndex, endIndex)}</span><!--
   *    --><span>${label.substring(endIndex, label.length)}</span>
   * `;
   */


  componentConnected() {
    this.disabledWatcher(this.disabled, this.disabled);
    this.addEventListener('click', this.onClickCapture); // we need to do this here and not on div.list because of shadydom polyfill support

    this.addEventListener('keydown', this.onKeyCapture);
  }

  componentDisconnected() {
    this.removeEventListener('click', this.onClickCapture);
    this.removeEventListener('keydown', this.onKeyCapture);
  }

  render() {
    return html`
    <div class="${classMap({
      container: true,
      expanded: this.expanded,
      placeholder: this.showPlaceholder
    })}">
      <label>${this.label}</label>
      <input .placeholder="${this.placeholder}"
             type="text"
             .value="${this.internalValue}"
             @input="${this.onInputInput}"
             @change="${this.onInputChange}"
             @keydown="${this.onInputKeyDown}"
             @click="${this.onClickCapture}"></input>
      <div class="currentvalue"><slot name="currentvalue"></slot></div>
      <davinci-spinner></davinci-spinner>
      <davinci-icon-ref .src="${this.icon}"></davinci-icon-ref>
      <div class="overlaywrapper" @click="${this.onClickCapture}">
      <div class="list" style="${styleMap(this.listStyle)}" ><slot @slotchange="${this.onListSlotChange}"></slot></div>
      </div>
    </div>
    `;
  }

  componentFirstRender() {
    // Safari (does not call @slotchange from above) fix -- https://github.com/whatwg/dom/issues/447
    this.onListSlotChange(null);
  }

  componentDidRender() {
    if (!this._listElement) {
      this._listElement = this.shadowRoot.querySelector('.list');
    }

    if (!this._overlayWrapper) {
      this._overlayWrapper = this.shadowRoot.querySelector('.overlaywrapper');
    }
  }

  selectItem(option) {
    const oldValue = this.internalValue;
    this.value = option.value || option.textContent;
    this._currentValueContainer.innerHTML = option.innerHTML || option.value;

    if (oldValue !== this.value) {
      this.change.emit(this.value);
    }

    this.expanded = false;
  }

  disabledWatcher(_oldValue, _newValue) {
    if (this._componentState === COMPONENT_STATE.CONNECTED) {
      this.setAttribute('tabindex', _newValue ? '-1' : '0');
    }
  }

  expandedWatcher(_oldValue, newValue) {
    if (!newValue) {
      if (this._currentSelection) {
        this._currentSelection.classList.remove('selected');

        this._currentSelection = null;
      }

      window.cancelAnimationFrame(this._currentAnimationFrame);
      this._currentAnimationFrame = null;
    } else {
      this._lastTopPosition = null;

      this._calculateListDimensions();

      this._currentAnimationFrame = window.requestAnimationFrame(this.onAnimationFrame);
    }
  }

  _findDavinciOption(element) {
    if (!element) {
      return null;
    } else if (element.tagName === 'DAVINCI-OPTION') {
      return element;
    } else {
      return this._findDavinciOption(element.parentElement);
    }
  }

  _calculateListDimensions() {
    const {
      top,
      height,
      left,
      width
    } = this.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (top !== this._lastTopPosition) {
      this._lastTopPosition = top;
      const bottomSpace = windowHeight - (top + height);
      const topSpace = top;

      if (bottomSpace > 150 || topSpace < 100) {
        // dropdown under control
        this.listStyle = {
          'top': `${top + height - 1}px`,
          'max-height': Math.min(bottomSpace - 10, 300) + 'px',
          'left': `${left}px`,
          'width': `${width}px`
        };
      } else {
        // dropdown list over control
        this.listStyle = {
          'bottom': windowHeight - top - 1 + 'px',
          'max-height': Math.min(topSpace - 10, 300) + 'px',
          'left': `${left}px`,
          'width': `${width}px`
        };
      }

      this.scheduleRender(true);
    }
  } // TODO: can be implemented much faster and cleaner :)


  _selectNextOption() {
    if (this._currentSelection) {
      let nextSibling = this._currentSelection.nextElementSibling;

      while (nextSibling && (nextSibling.tagName !== 'DAVINCI-OPTION' || nextSibling.disabled === true)) {
        nextSibling = nextSibling.nextElementSibling;
      }

      if (!nextSibling && this._currentSelection.parentElement.tagName === 'DAVINCI-OPTION-GROUP') {
        if (this._currentSelection.parentElement.nextElementSibling) {
          nextSibling = this._currentSelection.parentElement.nextElementSibling.children[0];

          while (nextSibling && (nextSibling.tagName !== 'DAVINCI-OPTION' || nextSibling.disabled === true)) {
            nextSibling = nextSibling.nextElementSibling;
          }
        }
      }

      if (nextSibling) {
        this._currentSelection.classList.remove('selected');

        this._currentSelection = nextSibling;

        this._currentSelection.classList.add('selected');

        this._scrollElementIntoView(this._currentSelection);
      }
    } else {
      for (let i = 0; i < this.children.length; i++) {
        // tslint:disable-line
        if (this.children[i].tagName === 'DAVINCI-OPTION' || this.children[i].tagName === 'DAVINCI-OPTION-GROUP') {
          if (this.children[i].tagName === 'DAVINCI-OPTION-GROUP') {
            if (this.children[i].children[0]) {
              this._currentSelection = this.children[i].children[0];

              this._currentSelection.classList.add('selected');

              this._scrollElementIntoView(this._currentSelection);

              return;
            }
          } else {
            this._currentSelection = this.children[i];

            this._currentSelection.classList.add('selected');

            this._scrollElementIntoView(this._currentSelection);

            return;
          }
        }
      }
    }
  }

  _scrollElementIntoView(scrollable) {
    const boundingRect = scrollable.getBoundingClientRect();

    const listRect = this._listElement.getBoundingClientRect();

    const top = listRect.top;
    const bottom = listRect.top + listRect.height;

    if (boundingRect.top < top || boundingRect.top + boundingRect.height > bottom) {
      // if element out of view
      this._listElement.scrollTop = this._listElement.scrollTop + (boundingRect.top + boundingRect.height - bottom);
    }
  } // TODO: can be implemented much faster and cleaner :)


  _selectPreviousOption() {
    if (this._currentSelection) {
      let previousSibling = this._currentSelection.previousElementSibling;

      while (previousSibling && (previousSibling.tagName !== 'DAVINCI-OPTION' || previousSibling.disabled === true)) {
        previousSibling = previousSibling.previousElementSibling;
      }

      if (!previousSibling && this._currentSelection.parentElement.tagName === 'DAVINCI-OPTION-GROUP') {
        if (this._currentSelection.parentElement.previousElementSibling) {
          previousSibling = this._currentSelection.parentElement.previousElementSibling.lastElementChild;

          while (previousSibling && (previousSibling.tagName !== 'DAVINCI-OPTION' || previousSibling.disabled === true)) {
            previousSibling = previousSibling.nextElementSibling;
          }
        }
      }

      if (previousSibling) {
        this._currentSelection.classList.remove('selected');

        this._currentSelection = previousSibling;

        this._currentSelection.classList.add('selected');

        this._scrollElementIntoView(this._currentSelection);
      }
    } else {
      for (let i = this.children.length - 1; i >= 0; i--) {
        // tslint:disable-line
        if (this.children[i].tagName === 'DAVINCI-OPTION' || this.children[i].tagName === 'DAVINCI-OPTION-GROUP') {
          if (this.children[i].tagName === 'DAVINCI-OPTION-GROUP') {
            if (this.children[i].children[0]) {
              this._currentSelection = this.children[i].children[0];

              this._currentSelection.classList.add('selected');

              this._scrollElementIntoView(this._currentSelection);

              return;
            }
          } else {
            this._currentSelection = this.children[i];

            this._currentSelection.classList.add('selected');

            this._scrollElementIntoView(this._currentSelection);

            return;
          }
        }
      }
    }
  }

  _createOptionList(dataList) {
    // const template = document.createElement('template');
    return html`${dataList.map(value => {
      if (value.data) {
        return html`<davinci-option-group label="${value.label}">
        ${value.data.map(dropDownOption => {
          return html`<davinci-option value="${dropDownOption.value}">${this.contentRenderer(dropDownOption.value, dropDownOption.label)}</davinci-option>`;
        })}
        </davinci-option-group>`;
      } else if (typeof value === 'string') {
        return html`<davinci-option value="${value}">${this.contentRenderer(value, value)}</davinci-option>`;
      } else {
        return html`<davinci-option value="${value.value}">
                    ${this.contentRenderer(value.value, value.label)}
                    </davinci-option>`;
      }
    })}`;
  }

}, _temp), (_descriptor = _applyDecoratedDescriptor(_class2.prototype, "name", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class2.prototype, "placeholder", [_dec5, _dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "editable", [_dec7, _dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "disabled", [_dec9, _dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "loading", [_dec11, _dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "label", [_dec13, _dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return '';
  }
}), _applyDecoratedDescriptor(_class2.prototype, "data", [_dec15, _dec16], Object.getOwnPropertyDescriptor(_class2.prototype, "data"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "value", [_dec17, _dec18], Object.getOwnPropertyDescriptor(_class2.prototype, "value"), _class2.prototype), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "expanded", [_dec19, _dec20], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "showPlaceholder", [_dec21, _dec22], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "change", [_dec23, _dec24], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "input", [_dec25, _dec26], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "contentRenderer", [_dec27, _dec28], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return (value, label) => html`<span>${label ? label : value}</span>`;
  }
}), _applyDecoratedDescriptor(_class2.prototype, "disabledWatcher", [_dec29, _dec30], Object.getOwnPropertyDescriptor(_class2.prototype, "disabledWatcher"), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, "expandedWatcher", [_dec31, _dec32], Object.getOwnPropertyDescriptor(_class2.prototype, "expandedWatcher"), _class2.prototype)), _class2)) || _class) || _class);
//# sourceMappingURL=DropDown.js.map